import {Entity} from 'app/core/main.entity';
import {Pagination} from './pagination.entity';

export class ApiResponse extends Entity {
  status = true;
  message = '';
  result: any = null;
  pagination: Pagination | null = null;

  constructor(options: Partial<ApiResponse> = null) {
    super();

    Object.assign(this, options);
  }
}
